import { gql } from "../../../../__generated__";

export const GET_USER_WALLET = gql(`
  query UserWallet {
    userWallet {
      id
      userId
      availableBalance
      heldBalance
      createdAt
      updatedAt
    }
  }
`);

export const GET_USER_WALLET_LEDGERS = gql(`
  query UserWalletLedgers {
    userWalletLedgers {
      id
      walletId
      type
      direction
      amount
      balanceAfterAvailable
      balanceAfterHeld
      refType
      refId
      memo
      createdAt
    }
  }
`);

export const GET_USER_WITHDRAWAL_REQUESTS = gql(`
  query UserWithdrawalRequests {
    userWithdrawalRequests {
      id
      walletId
      userId
      amountRequested
      feeAmount
      amountToPay
      status
      reviewerAccountId
      rejectReason
      externalTransferRef
      bankName
      accountNumberMasked
      accountHolder
      requestedAt
      reviewedAt
      paidAt
    }
  }
`);

export const CREATE_WITHDRAWAL_REQUEST = gql(`
  mutation CreateWithdrawalRequest($input: CreateWithdrawalRequestInput!) {
    createWithdrawalRequest(input: $input) {
      withdrawalRequestId
    }
  }
`);
